import React from 'react';
import { team, trustBadges } from '../mock';
import { Linkedin, BadgeCheck, Award, ShieldCheck, TrendingUp } from 'lucide-react';
import { SectionHeader } from './Services';

const iconMap = { BadgeCheck, Award, ShieldCheck, TrendingUp };

const Team = () => {
  return (
    <section className="relative py-20 md:py-28">
      <div className="squiggle-bg" />
      <div className="max-w-6xl mx-auto px-6 relative">
        <SectionHeader
          eyebrow="Meet the Founders"
          title={<>Founders Behind the <em className="italic">Strategy</em></>}
          description="Koushik Rahul S and Sijo Jacob Joseph lead Eduvantage with hands-on US tax, training, and career strategy experience."
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8 max-w-4xl mx-auto">
          {team.map((m, i) => (
            <div key={i} className="card-soft rounded-2xl overflow-hidden group">
              <div className="aspect-[4/5] overflow-hidden bg-[#e8e2d1]">
                <img
                  src={m.image}
                  alt={m.name}
                  className={`w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 ${m.name.includes('Koushik') ? 'object-[center_18%] scale-110' : 'object-[center_20%]'}`}
                />
              </div>
              <div className="p-6">
                <h3 className="font-body font-semibold text-[#143324] text-xl mb-1">{m.name}</h3>
                <p className="text-[13px] text-[#3d3d3d] font-body mb-4">{m.role}</p>
                <p className="text-[13px] text-[#3d3d3d] font-body leading-relaxed mb-4">{m.bio}</p>
                <a
                  href="https://www.linkedin.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1.5 text-[13px] text-[#143324] font-body hover:gap-2.5 transition-all duration-300"
                >
                  <Linkedin size={14} /> Linkedin Profile
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 border-t border-[#143324]/10 pt-8">
          <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
            {trustBadges.map((b, i) => {
              const Icon = iconMap[b.icon];
              return (
                <div key={i} className="flex items-center gap-2 text-[#1c1c1c]">
                  {Icon && <Icon size={18} className="text-[#143324]" strokeWidth={1.6} />}
                  <span className="text-sm font-body">{b.label}</span>
                  {i < trustBadges.length - 1 && <span className="hidden md:inline text-[#143324]/25 ml-6">|</span>}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
